module.exports = __webpack_public_path__ + "img/ective_300Ah.ce60b127.png";